module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('iframe', {
    staticStyle: {
      "border": "1px solid #CCC",
      "border-width": "1px",
      "margin-bottom": "5px",
      "max-width": "100%",
      "height": "1000px"
    },
    attrs: {
      "id": "catelogFrame",
      "src": _vm.catalogueUrl,
      "width": "100%",
      "height": "800",
      "frameborder": "0",
      "marginwidth": "0",
      "marginheight": "0",
      "scrolling": "no",
      "allowfullscreen": ""
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-076dcf54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/ProductCatelogue.vue
// module id = 2062
// module chunks = 1